import { ref, computed } from "vue";
import { store } from "@/store";

import { addUserObject, getObjectProperty } from "@/canvas-api/Canvas";

interface BackUpImage {
  imageId: number;
  data: string;
}

const dpi = computed(() => store.getters.dpi);

const imageId = ref(1);
const imageStack = ref<BackUpImage[]>([]);

//Scale images to 300 DPI
export const scaledDPI = dpi.value / 300;

export const imgString = ref("");
export const backUpImgString = ref(""); //Used in CropImageModal when re-crop is triggered in EditImage

export const image = ref<fabric.Image>();
export const addNewImage = (newImg: fabric.Image, dataUrl?: string): void => {
  newImg.set({
    name: "image",
    originX: "center",
    originY: "center",
    stroke: "#0001ba",
    strokeWidth: 0,
    opacity: 1,
    selectable: true,
    evented: true,
    scaleX: scaledDPI,
    scaleY: scaledDPI,
    imageId: imageId.value,
  });

  if (dataUrl && dataUrl.length) {
    addBackUpImg({ imageId: imageId.value, data: dataUrl });
  }

  addUserObject(newImg);
  imageId.value += 1;
};

export const updateImage = (prop: string, value: string | boolean | number | number[] | undefined): Promise<void> => {
  return new Promise((resolve, reject) => {
    getObjectProperty({ name: prop, value: value, });
    resolve();
  });
};

const addBackUpImg = (backUp: BackUpImage) => {
  if (imageStack.value.length > 15) {
    imageStack.value.shift();
  }

  imageStack.value.push(backUp);
};

export const getBackUpImage = (imgId: number): string => {
  const found = imageStack.value.find((backUp) => backUp.imageId === imgId);

  if (found) {
    return found.data;
  } else {
    throw new Error("No matching image id");
  }
};
